import {Label} from '@primer/react'
import clsx from 'clsx'

import type {IterationLabelType} from '../../../helpers/iterations'
import {Resources} from '../../../strings'
import styles from './iteration-label.module.css'

interface IterationLabelProps {
  labelType: IterationLabelType
  className?: string
}

/**
 * Standalone label to highlight an iteration as the current one.
 */
export function CurrentIterationLabel({className}: {className?: string}) {
  return <Label className={clsx(styles.SelectedLabel, className)}>{Resources.iterationLabel.current}</Label>
}

/**
 * Generic label for use in the iteration field settings table. This is specifically sized
 * and padded to work in the table. For a standalone label for the current iteration, use
 * `CurrentIterationLabel`.
 */
export function IterationRowLabel({labelType, className}: IterationLabelProps) {
  const text = Resources.iterationLabel[labelType]
  const labelClass =
    labelType === 'current' ? styles.SelectedLabel : labelType === 'break' ? styles.BreakLabel : styles.DefaultLabel

  return (
    <div className={clsx(styles.IterationRowContainer, className)}>
      <Label className={clsx(styles.IterationRowLabel, labelClass)} as="span">
        {text}
      </Label>
    </div>
  )
}

try{ CurrentIterationLabel.displayName ||= 'CurrentIterationLabel' } catch {}
try{ IterationRowLabel.displayName ||= 'IterationRowLabel' } catch {}